import { render, staticRenderFns } from "./KeywordChartPerson.vue?vue&type=template&id=5bbbd2ba&scoped=true&"
import script from "./KeywordChartPerson.vue?vue&type=script&lang=js&"
export * from "./KeywordChartPerson.vue?vue&type=script&lang=js&"
import style0 from "./KeywordChartPerson.vue?vue&type=style&index=0&id=5bbbd2ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbbd2ba",
  null
  
)

export default component.exports